export enum EHandler {
    HANDLE_SUCCESS = 'handleSuccess',
    HANDLE_ERROR = 'handleError'
}
